/*
 * @Date: 2021-11-11 14:47:59
 * @LastEditTime: 2021-11-24 16:32:00
 * @LastEditors: Please set LastEditors
 * @Description: 集成epas网关的js helper工具
 */
import FlyCrypto from "./crypto";
// import storage from "../utils/storage";
// import { getDateNow } from "../utils/system-time-handler";

/**
 * querystring对象序列化
 * @param {object} params
 * @returns
 */
export const queryString = (params) => {
  const result = [];
  for (const key of Object.keys(params)) {
    result.push(`${key}=${params[key]}`);
  }
  return result.join("&");
};

// 添加验签参数URI的处理：去掉域名部分 -> 解决语音转写接口验签失败问题
const wrapUri = (url) => {
  if (url.startsWith("http")) {
    const IS_PROD_ENV = process.env.NODE_ENV !== "development";
    const protocol = IS_PROD_ENV ? "https" : "http";
    const HTTP_BASE_API = `${protocol}://${window.shield.ShieldConfig.host}`;
    const baseUrl = IS_PROD_ENV
      ? HTTP_BASE_API
      : window.shield.ShieldConfig.braveCfg.baseUrl;
    return url.replace(baseUrl, "");
  }
  return url;
};

function getAuthExpries() {
  const timestamp = (new Date()).getTime() + 20 * 60 * 1000;
  return timestamp;
}
// 运营中心授权
function getAuthorization(appKey, appSecret, url, timestamp) {
  const signToString = `${url}\n${timestamp}`;
  // eslint-disable-next-line no-undef
  const sha1Value = CryptoJS.HmacSHA1(signToString, appSecret);
  // eslint-disable-next-line no-undef
  const base64Value = CryptoJS.enc.Base64.stringify(sha1Value);
  const signature = base64Value.replace(new RegExp("/", "gm"), "_").replace(new RegExp("\\+", "gm"), "-");
  /* alert(`signToString=${signToString};sha1Value=${sha1Value};base64Value=${base64Value};signature=${signature}`) */
  const authorization = "OPC " + appKey + ":" + signature;
  return authorization;
}

function setOpcReqHeader(config) {
  const strUrl = config.url.split("/").join("/");
  // 调用接口=运营中心
  if (strUrl.includes("opc-operation-api")) {
    // config.baseURL = window.shield.ShieldConfig.braveCfg.szhpt.baseUrl;
    const timestamp = getAuthExpries();
    const { appId, appSecret } = window.shield.ShieldConfig.braveCfg.szhptConfig;
    config.headers["X-Opc-Expires"] = timestamp;
    config.headers["X-Opc-Key"] = appId;
    console.log("22233", appId, appSecret, strUrl, timestamp);
    config.headers["X-Opc-Authorization"] = getAuthorization(appId, appSecret, strUrl, timestamp);
    delete config.headers["S-Auth-Token"];
  }
}
export function setRequestHeader(Req) {
  const CONFIG = FlyCrypto.getConfig();
  if (CONFIG) {
    const Timestamp = Date.now();
    const { appId, appSecret, stage } = CONFIG;
    const headers = Req.headers;
    const authNonce = FlyCrypto.creatUuid();
    // pathURL为后端接口的路径，不包括域名（eg:/acs-schedule/calendar/v1/listSchoolCalendar）务必要传对，不然会提示签名失败。。。
    const pathURL = wrapUri(Req.url);
    headers["S-Auth-AppId"] = appId;
    headers["S-Auth-Nonce"] = authNonce;
    headers["S-Auth-Signature"] = FlyCrypto.signature(
      appSecret,
      pathURL,
      authNonce,
      Timestamp,
      appId,
      ""
    );
    headers["S-Auth-Stage"] = stage;
    headers["S-Auth-Timestamp"] = Timestamp;
    headers["S-Auth-Version"] = "1";
    headers["S-Auth-Token"] = "";

    headers["S-Auth-ClientType"] = "web";
    headers["S-Auth-DeviceId"] = window.SSO?.deviceId || "";
    headers["S-Auth-Mac"] = window.SSO?.deviceId || ""; // 和token有关
    setOpcReqHeader(Req);
  }
}
